import { createContext } from "react";

export const UserContext = createContext(null);
export const IssuerContext = createContext(null);
export const IssuanceDetailContext = createContext(null);
export const MarkRoosLocalObligContext = createContext(null);